import { ColSize } from "antd/lib/col";
import styled from "styled-components";
import Form from "antd/lib/form";
import ScreenHelper from "components/Styled/ScreenHelper";

declare type ColSpanType = ColSize;

export const EmailColLayout: { [key: string]: ColSpanType } = {
    xs: { span: 12, offset: 1 },
    sm: { span: 12, offset: 1 },
    md: { span: 12, offset: 1 },
    lg: { span: 24, offset: 1 },
    xl: { span: 24, offset: 1 },
};


export const ButtonColLayout: { [key: string]: ColSpanType } = {
    xs: { span: 18 },
    sm: { span: 18 },
    md: { span: 18 },
    lg: { span: 10 },
    xl: { span: 10 },
};

export const InputLayout = {

    labelCol: {
        xs: { span: 24, },
        sm: { span: 24, },
        md: { span: 24, },
        lg: { span: 2, },
        xl: { span: 2, },
    },
    wrapperCol: {
        xs: { span: 22 },
        sm: { span: 22, },
        md: { span: 22, },
        lg: { span: 18, },
        xl: { span: 18, },
    },
};

export const StyleResendEmailConfirmationForm = styled(Form)`

${ScreenHelper.down('sm')`
    max-width: 300px;
    min-width: 300px;

    text-align: center;
`}
.text{
    margin-top: 10px;
}

.resendEmailBtnRow{ 
    justify-content: center;
    align-items: center;
}
.resendEmailBtn{ 
     margin: 4;
     width: 100%;
}

.emailFormRow{
    margin-top: 10;
}
.emailFormCol{
    width: 100%
}
 
`;